import { all } from "redux-saga/effects";
import authSagas from "./authSagas";
import danhMucSagas from "./danhMucSagas";
import khoSagas from "./khoSagas";
import banhangSagas from "./BanHangSaga/BanHangSagas";
import danhMucNhomSanPham from "./DanhMucSaga/DanhMucNhomSanPhamSagas";
import danhMucAttributes from "./DanhMucSaga/DanhMucAttributesSagas";
import hethongNTSagas from "./HeThongNTSaga/HeThongNTSagas";
import chinhanhSagas from "./DanhMucSaga/ChiNhanhSagas";
import userSagas from "./UserSaga/UserSagas";
import DanhSachDonDatHangSagas from "./DanhSachDonDatHangSagas";
import DanhSachDonHangSaga from "./DanhSachDonHangSaga";
export default function* rootSaga() {
  yield all([
    authSagas(),
    danhMucSagas(),


    khoSagas(),
    danhMucNhomSanPham(),
    danhMucAttributes(),
    banhangSagas(),
    hethongNTSagas(),
    chinhanhSagas(),
    userSagas(),

    DanhSachDonDatHangSagas(),
    DanhSachDonHangSaga()
  ]);
}
